import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconDownload from '@/icons/Download.svg';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { Item } from './Item';

export const ArticleProofOfPurchase = () => {
  const { t } = useLingui();
  const { proofOfPurchaseMedia } = useArticleContext();

  const proofOfPurchase = proofOfPurchaseMedia?.[0];

  return (
    <Item
      label={t({
        id: 'article.information.proof-of-purchase',
        message: 'Proof of purchase',
      })}
    >
      {proofOfPurchase && (
        <Stack row flexWrap="nowrap" gap="0.25rem">
          <InlineText weight="medium" ellipsis>
            {proofOfPurchase.originalPath}
          </InlineText>
          <Button
            href={proofOfPurchase.url}
            download
            variant="secondary"
            iconOnly
            size="small"
            tooltip={t({ id: 'article.information.download', message: 'Download' })}
          >
            <IconDownload className="text-secondary" />
          </Button>
        </Stack>
      )}
    </Item>
  );
};
